import {useMemo} from "react";
import CategoryTable from "../components/CategoryTable";
import CategoryUpsertDialog from "../components/CategoryUpsertDialog";
import {Category, SortField, useCategories, useDeleteCategory} from "@/hooks/useCategories.ts";
import HeaderTextButton from "@/components/HeaderTextButton.tsx";
import {useQueryModal} from "@/hooks/useQueryModal.ts";
import {useTableQuery} from "@/hooks/useTableQuery.ts";

export default function AdminCategoriesPage() {
    const {
        searchParams,
        editId,
        isNew,
        modalOpen,
        setParam,
        openCreate,
        openEdit,
        closeModal,
    } = useQueryModal();

    const {
        page,
        size,
        sortBy,
        sortOrder,
        setPage,
        onRequestSort,
    } = useTableQuery<SortField>({
        searchParams,
        setParam,
        defaultPage: 0,
        defaultSize: 10,
        defaultSortBy: "name",
        defaultSortOrder: "desc",
    });

    const {
        data: result = {page, size, total: 0, items: []} as any,
        isLoading,
        isError
    } = useCategories({page, size, sortBy, sortOrder});

    const {mutateAsync: deleteCategory} = useDeleteCategory();

    const initialForDialog: Partial<Category> | null = useMemo(() => {
        if (isNew) return null;
        if (editId) return result.items.find((c: Category) => c.id === editId) ?? null;
        return null;
    }, [isNew, editId, result]);

    return (
        <>
            <HeaderTextButton
                title="Categories"
                description="Manage news categories."
                label="Add Category"
                onClick={openCreate}
            />

            <CategoryTable
                content={result}
                isLoading={isLoading}
                isError={isError}
                onCreate={openCreate}
                onEdit={openEdit}
                onDelete={deleteCategory}
                setPage={setPage}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onRequestSort={onRequestSort}
            />

            <CategoryUpsertDialog
                open={modalOpen}
                initial={initialForDialog}
                onClose={closeModal}
            />
        </>
    );
}
